jQuery(document).ready(function ($) {
  let notifications = new Array();

  if (JSON.parse(localStorage.getItem("user_info"))?.notifications) {
    notifications = JSON.parse(localStorage.getItem("user_info")).notifications;
  }

  if (window.location.pathname.includes("/notification")) {
    if (notifications.length) {
      let data = `&action=show_notifications&notifications=${JSON.stringify(
        notifications
      )}`;

      $.ajax({
        type: "POST",
        dataType: "html",

        url: show_notifications.ajaxurl,
        data: data,

        success: function (res) {
          $("#my-notifications-loading").remove();

          let notifications_template = JSON.parse(res)?.template;

          $("#notifications_listing").append(notifications_template);
        },
        error: function (jqXHR, textStatus, errorThrown) {
          console.log(jqXHR);
          console.log(textStatus);
          console.log(errorThrown);
        },
      });
    } else {
      $("#my-notifications-loading").remove();
      $("#notifications_listing").
      append(
        `<h2 class="no-notifications">لا توجد إشعارات</h2>`
      );
    }
  }

  if (notifications.length) {
    $("#my_notifications_count")
      .html(notifications.length)
      .css("display", "inline-block");
  }
});
